import React from 'react';
import ExperimentContext from './ExperimentContext';
import PropTypes from 'prop-types';

const errorMsg = (name) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(`[Abacus] Missing experiment: ${name}.`);
  }
};

const Experiment = ({ name, children }) => (
  <ExperimentContext.Consumer>
    {(experiments) => {
      const experiment = experiments[name];
      let value;
      if (!experiment) {
        errorMsg(name);
        value = null;
      } else {
        value = experiment.value;
      }
      return children(value, experiment);
    }}
  </ExperimentContext.Consumer>
);

Experiment.propTypes = {
  children: PropTypes.func.isRequired
};

export default Experiment;



// WEBPACK FOOTER //
// ./src/universal/components/Experiment/Experiment.js